import { createContext } from 'react';
var SeriesContext = createContext();
SeriesContext.displayName = 'SeriesContext';
export default SeriesContext;